import { orderBy } from 'lodash-es';

export type MergeOrder = 'effective' | 'finalised';

interface MergeOrderable {
  status: string;
  created_at: string;
  updated_at?: string;
  effective_date?: string;
}

// 'FINAL' literal, not ResourceState.FINAL — importing domain/schemas/contract.schema here creates
// an import cycle back into this barrel and leaves its schemas undefined at module init.
export const getFinalisedAtDate = <T extends MergeOrderable>(endorsement: T): string | undefined =>
  endorsement.status === 'FINAL' ? endorsement.updated_at : undefined;

const getEffectiveDate = <T extends MergeOrderable>(endorsement: T): string | undefined => endorsement.effective_date;
const getCreatedAt = <T extends MergeOrderable>(endorsement: T): string => endorsement.created_at;

export const sortEndorsementsForMerge = <T extends MergeOrderable>(endorsements: T[], order: MergeOrder): T[] =>
  orderBy(endorsements, [
    order === 'effective' ? getEffectiveDate : getFinalisedAtDate,
    getFinalisedAtDate,
    getCreatedAt,
  ]);
